import gql from 'graphql-tag';

export const getPlanProgressDetail = gql`
  query getPlanProgressDetail(
    $acadPlan: String!
    $prog: String!
    $career: String!
  ) {
    planProgress {
      detail(acadPlan: $acadPlan, prog: $prog, career: $career) {
        isProcessing
        items {
          status
          term
          name
          courseId
          code
          credits
          type
          hours
          term
          name
          courseId
          code
          credits
          prerequisites {
            code
            name
          }
        }
      }
    }
  }
`;

export const getPlanProgressEquivalences = gql`
  query getPlanProgressEquivalences(
    $courseId: String!
    $courseList: [String!]!
  ) {
    planProgress {
      equivalences(courseId: $courseId) {
        code
        name
      }
      preRequisites(courseList: $courseList) {
        code
        name
      }
      courseMatch(courseList: $courseList) {
        courseList_pre
        courseId_pre
        courseId
        equivalence
        name
        course
      }
    }
  }
`;

export const getPlanProgressResume = gql`
  query getPlanProgressResume($acadPlan: String!, $prog: String!) {
    planProgress {
      resume(acadPlan: $acadPlan, prog: $prog) {
        isProcessing
        requiredCourses {
          approved
          pending
          total
        }
        credits {
          required {
            approved
            pending
            total
          }
          optional {
            approved
            pending
            total
          }
          onsite {
            approved
            percent
          }
          virtual {
            approved
            percent
          }
          resume {
            total
            approved
            pending
            approvedPercent
            pendingPercent
          }
        }
      }
    }
  }
`;

export const getPlanProgressPS = gql`
  mutation getPlanProgressPS($prog: String!, $plan: String!) {
    academicPlanProgressPS(prog: $prog, plan: $plan)
  }
`;
